module.exports = __webpack_public_path__ + "static/media/second-image.ae1b1515.png";